(function() {
	
	var State = include("springroll.State"),
		Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Button = include("springroll.pixi.Button");
	
	var TitleState = function(options)
	{
		State.call(this, new heist.TitlePanel(), options);
		
		this.onBGTouched = this.onBGTouched.bind(this);
		this.onGameButton = this.onGameButton.bind(this);
		
		this.on('loading', this.onLoading);
		this.on('loaded', this.onLoaded);
		
		this.isFirstVisit = true;
	};
	
	// Extend State
	var s = State.prototype;
	var p = TitleState.prototype = Object.create(s);
	
	p.onLoading = function(assets)
	{
		if(this.isFirstVisit)
			assets.append(this.app.config.assets.mainTransition);
		
		this.app.music = "TitleLoop";
	};
	
	p.onLoaded = function()
	{
		this.panel.setup(this.app.hasTouch || !this.isFirstVisit);
	};
	
	p.enterDone = function()
	{
		//do things if this is the first visit to the state, aka not a replay
		if(this.isFirstVisit)
		{
			this.app.trackEvent(["load", "Complete"]);
			
			if(this.app.hasTouch)
			{
				this.app.voPlayer.play("Elmo_TapPlayButton");
			}
			else
			{
				this.app.trackEvent(["start", "NotStartButton"]);
				this.app.voPlayer.play("Elmo_Title", this.startGame.bind(this));
			}
			//also set up the transition
			this.app.createMainTransition();
		}
		//do replay stuff
		else
		{
			this.app.voPlayer.play("Nar_PlayAgainChooseButton");
		}
		//for mobile or replay, add listeners
		if(this.panel.playButton)
		{
			var background = this.panel.background;
			background.interactive = true;
			background.on("touchend", this.onBGTouched);
			background.on("mouseup", this.onBGTouched);
			this.panel.playButton.on("buttonPress", this.onGameButton);
		}
	};
	
	p.onBGTouched = function()
	{
		this.disableInput();
		if(this.isFirstVisit)
		{
			this.app.trackEvent(["start", "NotStartButton"]);
			this.playVO();
		}
		else
			this.startGame();
	};
	
	p.onGameButton = function()
	{
		this.disableInput();
		if(this.isFirstVisit)
		{
			this.app.trackEvent(["start", "StartButton"]);
			this.playVO();
		}
		else
			this.startGame();
	};
	
	p.disableInput = function()
	{
		this.panel.background.interactive = false;
		this.panel.playButton.enabled = false;
	};
	
	p.playVO = function()
	{
		this.app.voPlayer.play("Elmo_Title", this.startGame.bind(this));
	};
	
	p.startGame = function()
	{
		this.app.voPlayer.stop();
		this.app.cutsceneData =
		{
			nextState: "stealth",
			cutscene: "intro",
			skipLabel: "IntroAnim"
		};
		this.manager.state = "cutscene";
	};
	
	p.exit = function()
	{
		s.exit.call(this);
		this.app.unload(this.app.config.assets.loadTransition);
		
		this.panel.teardown();
		
		this.isFirstVisit = false;
	};
	
	p.destroy = function()
	{
		var p = this.panel;
		s.destroy.call(this);
		if(p.destroy)
			p.destroy();
	};
	
	namespace('heist').TitleState = TitleState;
}());